import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-fin-promo',
  templateUrl: './fin-promo.component.html',
  styleUrls: ['./fin-promo.component.scss']
})
export class FinPromoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
